import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { DropdownService } from '../dropdown-service/dropdown.service';
import { DropdownModule } from '../dropdown.module';
import { Step } from './multi-step-dropdown.component';
import { TDropdown } from '../dropdown.consts';

@Component({
  selector: 'pp-multi-step-dropdown-container',
  styleUrls: ['./multi-step-dropdown-container.component.scss'],
  templateUrl: './multi-step-dropdown-container.component.html',
  imports: [DropdownModule],
})
export class MultiStepDropdownContainerComponent implements OnInit, OnDestroy {
  steps: Step[] = [];
  backCallback?: () => void;
  isLoading = false;
  dropdownWidth: string;
  selectedId: string;
  selectedParentId: string;

  private readonly destroy$ = new Subject<void>();
  private dropdown: TDropdown = this.dropdownService.getDropdown();

  constructor(private dropdownService: DropdownService) {}

  ngOnInit(): void {
    this.readDropdownData();

    this.dropdownService.dropdownDataChanged$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.readDropdownData();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  private readDropdownData(): void {
    const allSteps = this.dropdown.data?.steps ?? [];
    this.steps = allSteps;
    this.backCallback = this.dropdown.data?.backCallback;
    this.isLoading = this.dropdown.data?.isLoading ?? false;
    this.dropdownWidth = this.dropdown.data?.width;
    this.selectedId = this.dropdown.data?.selectedId ?? null;
    this.selectedParentId = this.dropdown.data?.selectedParentId ?? null;
  }
}
